import React from 'react';
import NointernetPage from '../../assets/images/No internet-vector.png';
import '../../assets/scss/page/_notfound.scss';
import { TNButton } from './TNButton';
import { Container, Navbar } from 'react-bootstrap';
import DashboardLogo from '../../assets/images/technource-logo.png';
export default function NoInternetPage() {
  const handleClick = () => {
    window.location.reload();
  };
  return (
    <>
      <Navbar className="sticky-top navbar-section">
        <Container fluid className="container-section">
          <Navbar.Brand className="dashboard-logo">
            <img
              src={'/admin' + DashboardLogo}
              alt="dashboardlogo"
              className="nav-brand popup_img"
            />
          </Navbar.Brand>
        </Container>
      </Navbar>
      <div className="page-not-found">
        <img
          src={'/admin' + NointernetPage}
          alt="no-internet"
          className="not-found-image popup_img"
        />
        <h1 className="page-heading-center">Oops!</h1>
        <div className="error-page-text">NO INTERNET CONNECTION,PLEASE CHECK YOUR INTERNET </div>
        <div className="primary-button">
          <TNButton loading={false} type="button" onClick={handleClick}>
            Try Again
          </TNButton>
        </div>
      </div>
    </>
  );
}
